var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sections"},_vm._l((_vm.invadobay_sections.filter(
      (i) => !!i
    )),function(invadobay_section,index){return _c('section',{key:`invadobay:${invadobay_section.preview_type}:${index}`,staticClass:"section"},[_c('invadobay-previews',{attrs:{"invadobay_section":invadobay_section}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }